import { notification } from 'antd';
import { NotificationPlacement } from 'antd/es/notification/interface';

type NotificationType = 'success' | 'info' | 'warning' | 'error';
type NotificationOpts = {
  type: NotificationType;
  message: string;
  description: string;
  placement?: NotificationPlacement;
};

type Notification = {
  showNotification: (opts: NotificationOpts) => void;
  contextHolder: React.ReactElement<
    any,
    string | React.JSXElementConstructor<any>
  >;
};

export const useNotification = (): Notification => {
  const [api, contextHolder] = notification.useNotification();

  const showNotification = ({
    type,
    message,
    description,
    placement = 'topRight',
  }: NotificationOpts) => {
    api[type]({
      message,
      description,
      placement,
    });
  };

  return { showNotification, contextHolder };
};
